import { AfterViewInit, Directive, ElementRef, HostBinding } from '@angular/core';

@Directive({
    selector: '[ndtPortraitView]',
    standalone: false
})
export class ReportOutputContainerPortraitDirective implements AfterViewInit {
   @HostBinding('class')
   elementClass = 'portrait';

   constructor(private elementRef: ElementRef) {}

   ngAfterViewInit(): void {
      const reportContainer = this.elementRef.nativeElement;
      const style: HTMLStyleElement = document.createElement('style');
      const css = '@page { size: a4 portrait; }';

      if (reportContainer) {
         style.appendChild(document.createTextNode(css));
         reportContainer.appendChild(style);
      }
   }
}
